import request from '@/utils/request'

export function connectWebSocket() {
  return request({
    url: '/ws',
    method: 'get',
  })
}
